import {
  SequenceEmailIcon,
  SequenceFallbackIcon,
  SequenceSmsIcon,
  SequenceTogetherIcon
} from 'features/CustomCampaigns/EditCampaign/CampaignFlowIcons'
import {
  dripMediumDescriptions,
  dripMediumNames,
  dripMediumOptions
} from 'features/CustomCampaigns/EditCampaign/CampaignSetup'

export const dripMediumIcons = {
  [dripMediumOptions.Email]: SequenceEmailIcon,
  [dripMediumOptions.Text]: SequenceSmsIcon,
  [dripMediumOptions.EmailAndText]: SequenceTogetherIcon,
  [dripMediumOptions.TextWithEmailFallback]: SequenceFallbackIcon
}

export const dripMediumOrder = [
  dripMediumOptions.Email,
  dripMediumOptions.Text,
  dripMediumOptions.EmailAndText,
  dripMediumOptions.TextWithEmailFallback
]

export function getDripMediumIcon(medium) {
  return dripMediumIcons[medium] || SequenceEmailIcon
}

export function getDripMediumName(medium) {
  return dripMediumNames[medium] || ''
}

export function getDripMediumDescription(medium) {
  return dripMediumDescriptions[medium] || ''
}

export function getDefaultCampaignName(medium, existingNames = []) {
  const label = getDripMediumName(medium)

  if (!label) {
    return 'Untitled campaign'
  }

  const base = `${label} campaign`
  const taken = new Set(existingNames.map(name => String(name).toLowerCase()))

  let counter = 1
  while (taken.has(`${base} ${counter}`.toLowerCase())) {
    counter += 1
  }

  return `${base} ${counter}`
}
